// app/attivitaControllo/attivitaControllo.js

(function () {
    'use strict';
    var controllerId = 'attivitaControllo';
    angular.module('app').controller(controllerId, ['$rootScope', '$routeParams', '$filter', 'common', 'bootstrap.dialog', '$uibModal', 'datacontext', 'sectionMenu', attivitaControlloFn]);

    function attivitaControlloFn($rootScope, $routeParams, $filter, common, bDialog, $uibModal, datacontext, sectionMenu) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard 

        var vm = this;
        vm.title = 'Attività';
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection('AttivitaControllo');                
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.addDisabled = true;
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;
        vm.tableHeight = 0;

        vm.super = $rootScope.isAuthorized('SUPER');
        vm.personale = $rootScope.isAuthorized('PERSONALE');
        //vm.sync = true;
                
        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ['Sezione', '% Ore Spese Sezione'];
        vm.ordine = vm.list.ordine[0];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
            vm.cerca();
        };
        
        //Filtro
        vm.filter = {};        
        vm.filter.ricerca = vm.fRicerca = '';
        
        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;                              

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [];
            common.activateController(promises, controllerId)
                .then(function () {
                    
                });
        }

        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function cerca() {
            if (vm.fRicerca.trim().length < 3) {
                logError('Digita almeno 3 caratteri nella casella di ricerca');
                return;
            }                

            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;            
            vm.filter.ricerca = vm.fRicerca == null ? '' : vm.fRicerca;

            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            vm.tableHeight = 0;
            return datacontext.attivitaControllo_countAll(vm.filter.ricerca).then(function (data) {
                if (data) {
                    vm.countRecords = data;

                    if (vm.countRecords < 10)
                        vm.tableHeight = vm.countRecords * 56;
                    else
                        vm.tableHeight = 540;
                }
            });
        }

        function getAllByFilter() {
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;            

            vm.loading = true;
            return datacontext.attivitaControllo_getAllByFilter(vm.pageSize, vm.page, vm.filter.ricerca, vm.ordine).then(function (data) {
                if (data.constructor === Array) {
                    vm.page++;
                    vm.records.push.apply(vm.records, data);                   
                }
                vm.loading = false;
            });            
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }       
               
    }
})();
